import React, { useEffect, useState } from "react"
import { Button, Icon, Image, Label, Popup } from "semantic-ui-react"
import { Images } from "../../assets/assets"
import { Optimon } from "./optimon"
import Drawer from 'react-modern-drawer'
import PropTypes from 'prop-types';
import 'react-modern-drawer/dist/index.css'

export const OptimonPopup = () => {
    const [threadId, setThreadId] = useState()
    const [functions, setFunctions] = useState()

    const handleOnChange = ({threadId}) => {
        setThreadId(threadId)
    }
    
    return <Popup position="top right" on="click" trigger={<Image className="optimon" src={Images.optimon} size="tiny" />} 
    header={
        <Popup.Header>
            <div style={{height: 32, display: "inline-flex", alignItems: "center"}}>Optimon thread id: {threadId}</div>
            <Button size="tiny" floated="right" basic icon="refresh" onClick={() => functions.reloadThread?.()}  />
            <Button size="tiny" floated="right" basic icon="edit outline"  onClick={() => functions.createThread?.()} />
        </Popup.Header>
    }
    content={
        <Popup.Content>
            <Optimon onChange={handleOnChange} setFunctions={setFunctions} />
         </Popup.Content>
    } />
}

export const OptimonDrawer = ({open, onClose}) => {
    const [threadId, setThreadId] = useState()
    const [functions, setFunctions] = useState()
    const [isOpen, setIsOpen] = React.useState(open)
    
    const onCloseDrawer = () => {
        setIsOpen(false)
        onClose?.()
    }

    useEffect(() => {
        setIsOpen(open)
    }, [open])
    

    const handleOnChange = ({threadId}) => {
        setThreadId(threadId)
    }

    return <Drawer
        open={isOpen}
        onClose={onCloseDrawer}
        direction='right'
        size={400}
        className="optimon-drawer"
    >  
    <Label attached="top" size="large">
    <Popup trigger={<span>Optimon</span>} content={"Thread: " + threadId} />
    <Popup trigger={<Icon style={{float: "right"}} link name="refresh" onClick={() => functions.reloadThread?.()}  />} content="Reload thread" />
    <Popup trigger={<Icon style={{float: "right"}} link name="edit outline"  onClick={() => functions.createThread?.()} />} content="New thread" />
    </Label> 
    <Optimon onChange={handleOnChange} setFunctions={setFunctions} />
</Drawer>
}

OptimonDrawer.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func
}